import MaldivesCharterTakeoverBackground from './components/MaldivesCharterTakeoverBackground'

const maldivesCharterTakeoverConfig: App.SiteTakeoverConfig = {
  id: 'maldives-charter',
  palette: 'inverse',
  verticals: new Set(['home']),
  backgroundElement: MaldivesCharterTakeoverBackground,
}

export default maldivesCharterTakeoverConfig
